<template>
  <div :class="className" id="select-package">
      <div class="tw-font-bold">กรอก Referral Code เพื่อแพ็คเกจพิเศษสำหรับคุณ</div>
      <div class="tw-container tw-text-center tw-mx-auto tw-flex tw-mt-6">
        <input
          class="tw-rounded-l-lg tw-p-3 tw-mr-0 tw-bg-white tw-border-solid tw-border-gray tw-border-t tw-border-b tw-border-l tw-border-r-0 tw-w-64"
          placeholder="Referral Code" type="text" v-model="referralCode"/>
        <button @click="onsubmit"
          class="tw-px-8 tw-rounded-r-lg tw-bg-light-green tw-text-white tw-font-bold tw-border-solid tw-border-gray tw-p-3 tw-border-t tw-border-b tw-border-r">
          รับสิทธิ์
        </button>
      </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import AlertPackage from './alert.package'

export default {
  name: 'RefCode',
  props: ['className','test'],
  comments:{
    AlertPackage
  },
   data: function () {
    return {
      referralCode: '',
    }
  },
  computed: mapState({
    refCodeObject: state => state.companies.refCodeObject,
  }),
  created() {
    this.$store.dispatch('companies/getList')
  },
  methods: {
    onsubmit: function (e) {
      e.preventDefault();
      if (this.referralCode.length > 0) {
        this.$store.dispatch('companies/getCheckRefCode', {newRefCode: this.referralCode})
      }
    },
  },
  watch: {
    refCodeObject: {
      handler: function (refCodeObject) {
        if(refCodeObject){
          this.referralCode = refCodeObject['refCode']
        }
      }
    }
  }
}
</script>
<style lang="scss">
#select-package {
  .v-input__append-outer {
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

</style>
